import { createStyles, makeStyles } from '@hawkins/styles';
export var tooltipStyles = function (theme) {
    var hawkinsVariables = theme.hawkinsVariables, hawkins = theme.hawkins;
    return createStyles({
        /** Class name to apply to the root of the tooltip */
        root: {
            maxWidth: 300,
            overflowWrap: 'break-word',
            pointerEvents: 'none',
            zIndex: hawkinsVariables.zIndexes.tooltip,
            '& .Hawkins-TextLink': {
                color: hawkins.persistent.textColorWhiteRegular,
            },
            '& .Hawkins-Text': {
                color: hawkins.persistent.textColorWhiteRegular,
            },
            '& .Hawkins-Heading': {
                color: hawkins.persistent.textColorWhiteRegular,
            },
        },
        /** Class name of the root element when the component is interactive. */
        rootInteractive: {
            pointerEvents: 'auto',
        },
        /** Class name applied to the tooltip (label wrapper) element if placement contains "bottom". */
        tooltipPlacementBottom: {},
        /** Class name applied to the tooltip (label wrapper) element if placement contains "left". */
        tooltipPlacementLeft: {},
        /** Class name applied to the tooltip (label wrapper) element if placement contains "right". */
        tooltipPlacementRight: {},
        /** Class name applied to the tooltip (label wrapper) element if placement contains "top". */
        tooltipPlacementTop: {},
        /** Class name to apply to the description */
        description: {
            fontWeight: 'normal',
            color: hawkins.persistent.textColorWhiteLight,
        },
        /** Class name to apply to the label/description container */
        labelDescriptionContainer: {
            '&+$labelDescriptionContainer': {
                marginTop: hawkinsVariables.spacings.space0,
            },
        },
        /** Class name to apply to the label/description */
        label: {},
    });
};
export var useTooltipStyles = makeStyles(tooltipStyles, { name: 'Hawkins-Tooltip' });
